import type {
  Gif,
  Image,
  Video,
} from '~publish/legacy/composer/composer/entities/factories'

export type MediaSlide =
  | { kind: 'image'; image: Image }
  | { kind: 'video'; video: Video }

export type MediaRun =
  | { kind: 'images'; images: Image[] }
  | { kind: 'video'; video: Video }

/**
 * Groups adjacent same-kind slides into runs, preserving slide order. Used by
 * previews that have no single component rendering mixed image/video slides
 * together — each run renders with the existing image or video component.
 */
export function toMediaRuns(slides: MediaSlide[]): MediaRun[] {
  const runs: MediaRun[] = []
  for (const slide of slides) {
    const lastRun = runs[runs.length - 1]
    if (slide.kind === 'image' && lastRun?.kind === 'images') {
      lastRun.images.push(slide.image)
    } else if (slide.kind === 'image') {
      runs.push({ kind: 'images', images: [slide.image] })
    } else {
      runs.push({ kind: 'video', video: slide.video })
    }
  }
  return runs
}

// A gif has no dedicated slide of its own — it renders as an image, same as
// everywhere else a gif reaches the wire (see mapAssets.ts).
export const gifAsImage = (gif: Gif): Image => ({
  url: gif.url,
  width: gif.width,
  height: gif.height,
  mediaType: gif.mediaType,
})
